import { createAsyncThunk } from "@reduxjs/toolkit";
import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";
import { api } from "./config/axiosConfig";

const getAPIConfig = () => {
    // if (!serviceId) return null;
    const envVarName = `REACT_APP_BASE_URL`;
    // const envVarName = `REACT_APP_BASE_URL_${page.toUpperCase().replace(/-/g, "_")}`;
    // const apiPath =serviceId;
    return {
        baseURL: process.env[envVarName],
        pdflist: `/autocoder/list`,
        uploadpdf: `/autocoder/upload`,
        removePdf: `/autocoder/delete`
    };
};

const BASE_URL_GPT = process.env.REACT_APP_BASE_URL_GPT;

export class AutoCoderUploadFolderModalAPI {
    getPdfList = createAsyncThunk(
        "",
        async () => {
            try {
                const { baseURL, pdflist } = getAPIConfig();
                setBaseURL(api, baseURL);
                const response = await api.get(`${pdflist}`, {});                
                // const filteredData = response.data.data.map(obj => ({
                //     ...obj,
                //     file: obj.file.filter(fileObj => fileObj.embedded !== false)
                // }));  
                const filteredData = response.data.data.files.map(obj => ({
                    ...obj
                }));
                // return filteredData;
                return {
                    filteredData,
                    // suggestionList: response.data.data.suggestions,
                    // departmentList: response.data.data.departments
                };
                // return response.data;
            } catch (error) {
                throw error;
            }
        }
    );

    getPdf = createAsyncThunk(
        "",
        async ({ serviceId, ...data }) => {
            try {
                const { baseURL, pdflist } = getAPIConfig();
                setBaseURL(api, baseURL);
                const response = await api.post(`/document/gpt/list/${data.fileName}`, { folder_name: data.folderName });
                return response.data;
            } catch (error) {
                throw error;
            }
        }
    );


    uploadPdf = createAsyncThunk(
        "uploadPdf",
        async (reqData, { rejectWithValue }) => {
            try {
                const { baseURL, uploadpdf } = getAPIConfig();
                // console.log(baseURL,"uajsnsn",uploadpdf);
                setBaseURL(api, baseURL);
                const response = await api.post(`${uploadpdf}`, reqData, {
                    headers: {
                        "Content-Type": `multipart/form-data; boundary=${reqData._boundary}`,
                    },
                });
                return response.data;
            } catch (error) {
                return rejectWithValue(error.response.data);
            }
        }
    )


    removePdf = createAsyncThunk(
        "",
        async ({ serviceId, ...data }, { rejectWithValue }) => {
            //console.log(serviceId,"nsjnsns",data);
            try {
                const { baseURL, removePdf } = getAPIConfig(serviceId);
                setBaseURL(api, baseURL);
                const response = await api.post(`${removePdf}`, data);
                return response.data;
            } catch (error) {
                return rejectWithValue(error.message);
            }
        }
    );
}
